export const Marquee = ({ items, className = "" }) => (
  <div className={`overflow-hidden py-4 sm:py-5 bg-ink text-cream ${className}`} data-testid="marquee-ribbon" aria-hidden="true">
    <div className="flex whitespace-nowrap animate-marquee w-max">
      {[0, 1].map((i) => (
        <div key={i} className="flex items-center shrink-0">
          {items.map((t, j) => (
            <span key={j} className="flex items-center font-mono2 text-xs sm:text-sm tracking-[0.25em] uppercase">
              <span className="px-6 sm:px-8">{t}</span>
              <span className="w-1.5 h-1.5 rotate-45 bg-terracotta inline-block" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
